import React, { useState, useContext, useEffect } from "react";

import {
  CssTableLine,
  CssSwitchSub,
  CssTableCountry,
  CssTableFlag,
  CssTableDays,
  CssInputDay,
  SelectSquare,
} from '../components/uikit2';




export const gcCountries = [
  {
    icon: "🇦🇺",
    name: "Australia",
    defaultPeriod: false,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true,
    blocked: [0, 1, 2, 3]
  },

  {
    icon: "🇧🇪",
    name: "Belgium",
    defaultPeriod: 3,
    val: "",
    min: 3,
    max: 254,
    blocked: [0, 1, 2, 3],
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇨🇦",
    name: "Canada",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 180,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇨🇳",
    name: "China",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇩🇰",
    name: "Denmark",
    defaultPeriod: 3,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇫🇮",
    name: "Finland",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇫🇷",
    name: "France",
    defaultPeriod: 7,
    val: "",
    min: 3,
    max: 180,
    blocked: [0, 1, 2, 3]
  },

  {
    icon: "🇩🇪",
    name: "Germany",
    defaultPeriod: 3,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇰🇷",
    name: "South Korea",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 180,
    blocked: [0, 1, 2, 3]
  },

  {
    icon: "🇳🇴",
    name: "Norway",
    defaultPeriod: 7,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇵🇱",
    name: "Poland",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇷🇺",
    name: "Russia",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 599.99,
    minPrice: 299.99,
    maxPrice: 1399.99,
    currency: "₽",
    currencyPre: false
  },

  {
    icon: "🇸🇦",
    name: "Saudi Arabia",
    defaultPeriod: 3,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇸🇪",
    name: "Sweden",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇬🇧",
    name: "UK",
    defaultPeriod: 3,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇺🇦",
    name: "Ukraine",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  },

  {
    icon: "🇺🇸",
    name: "USA",
    defaultPeriod: 30,
    val: "",
    min: 3,
    max: 365,
    defaultPrice: 19.99,
    minPrice: 1.99,
    maxPrice: 79.99,
    currency: "$",
    currencyPre: true
  }
];




export function getCountries () {
  debugger
  return gcCountries.map((oneCountry, ind) => ({
    label: (
      <CssTableCountry>
        <CssTableFlag>{oneCountry["icon"]}</CssTableFlag>
        {oneCountry["name"]}
      </CssTableCountry>
    ),
    value: ind
  }));
};